import { Component, OnInit } from '@angular/core';
import { SessionService } from '../shared/services/session/session.service';
import { Tip } from '../shared/domain/tip';
import { isNullOrUndefined } from 'util';
import { SystemConfig } from '../shared/config/system-config';
import { BettingService } from '../shared/services/betting/betting.service';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { BalanceService } from '../shared/balance/balance.service';

@Component({
    selector: 'vit-betting',
    templateUrl: './betting.component.html',
    styleUrls: ['./betting.component.scss']
})
export class BettingComponent implements OnInit {

    selectedNumbers: number[] = [];
    quickTippAmount: number;
    stake: number;
    showStakeInput: boolean = false;
    showQuickTipp: boolean = false;
    showSuccess: boolean = false;
    showError: boolean = false;
    amountOfRounds: number = 1;
    loading: boolean = false;
    drawingRounds: number[] = [];

    constructor(public sessionService: SessionService,
                public bettingService: BettingService,
                public router: Router,
                public balanceService: BalanceService,
                public route: ActivatedRoute) {
    }

    ngOnInit() {
        let restore: string = this.route.snapshot.params['restore'];
        if (restore === 'true') {
            this.sessionService.restoreState();
        }
        this.stake = Math.max(this.sessionService.lastStake, this.sessionService.settings.getMinStake(this.amountOfRounds));
        for (let i: number = 1; i <= this.sessionService.settings.maxDrawingRounds; i++) {
            this.drawingRounds.push(i);
        }
    }

    getMaxWin() {
        let winningPlan = this.sessionService.winningPlan.filter(wp => wp.amount === this.selectedNumbers.length)[0];
        if (winningPlan) {
            let odds: number = winningPlan.prices[winningPlan.prices.length - 1].odds;
            return this.stake * odds;
        } else {
            return 0;
        }
    }

    handleMaxStakeChanges(amountOfNumbers: number) {
        let maxStake: number = this.sessionService.settings.getMaxStake(amountOfNumbers, this.amountOfRounds);
        if (this.stake > maxStake) {
            this.stake = maxStake;
        }
    }

    handleMinStakeChanges(amountOfRounds: number) {
        let minStake: number = this.sessionService.settings.getMinStake(amountOfRounds);
        if (this.stake < minStake) {
            this.stake = minStake;
        }
    }

    timerIsZero(): boolean {
        let timerValue = this.sessionService.countdown.value.getValue();
        return !timerValue || (timerValue.getMinutes() === 0 && timerValue.getSeconds() <= 1);
    }

    select(n: number) {
        if (this.selectedNumbers.indexOf(n) > -1) {
            this.selectedNumbers.splice(this.selectedNumbers.indexOf(n), 1);
        } else {
            this.selectedNumbers.push(n);
            if (this.selectedNumbers.length > 8) {
                this.selectedNumbers.shift();
            }
        }

        this.handleMaxStakeChanges(this.selectedNumbers.length);
    }

    placeBet() {
        if (this.sessionService.currentBingoGameId) {
            this.loading = true;
            this.bettingService.placeBet(this.amountOfRounds, this.selectedNumbers, this.stake).subscribe((response: Response) => {
                if (response.json().Success) {
                    this.sessionService.lastStake = this.stake;
                    this.sessionService.addTip(new Tip(this.sessionService.tickets.length, this.selectedNumbers, this.amountOfRounds, this.stake));
                    this.showSuccess = true;
                    this.balanceService.updateBalance();
                } else {
                    this.showError = true;
                }
                this.loading = false;
            }, (error) => {
                this.showError = true;
                this.loading = false;
                console.error('ticket error', error)
            });
        }
    }

    setStake(stake: number) {
        if (!isNullOrUndefined(stake)) {
            this.stake = stake;
        }
        this.showStakeInput = false;
    }

    selectQuickTipp(n: number) {
        this.quickTippAmount = n;
        this.selectedNumbers = this.generateRandomNumbersInRange(n, SystemConfig.Constants.AMOUNT_OF_KENO_NUMBERS);
        this.showQuickTipp = false;
    }

    hideError() {
        this.showError = false;
    }

    hideSuccess() {
        this.showSuccess = false;
        this.selectedNumbers = [];
        this.stake = this.sessionService.settings.getMinStake(this.amountOfRounds);
        this.quickTippAmount = null;
        this.router.navigate(['']);
    }

    generateRandomNumbersInRange(amount: number, range: number) {
        let numbers: number[] = [];
        while (numbers.length < amount) {
            let rnd = Math.ceil(Math.random() * range);
            if (numbers.indexOf(rnd) > -1) continue;
            numbers[numbers.length] = rnd;
        }
        return numbers;
    }

}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/betting/betting.component.ts